import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, vModelText as _vModelText, withDirectives as _withDirectives, resolveDirective as _resolveDirective, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, vModelSelect as _vModelSelect, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-390c9e1b"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "form p-3" }
const _hoisted_2 = { class: "container" }
const _hoisted_3 = { class: "row" }
const _hoisted_4 = { class: "col-12 mb-3" }
const _hoisted_5 = {
  for: "name",
  class: "form-label"
}
const _hoisted_6 = { class: "col-12 mb-4" }
const _hoisted_7 = {
  for: "name",
  class: "form-label"
}
const _hoisted_8 = { class: "col-12 mb-4 d-flex justify-content-between" }
const _hoisted_9 = { class: "col-12 d-flex justify-content-center" }
const _hoisted_10 = {
  key: 0,
  class: "col-12 d-flex justify-content-between"
}
const _hoisted_11 = { class: "col-12 d-flex justify-content-between" }
const _hoisted_12 = { key: 0 }
const _hoisted_13 = ["disabled"]
const _hoisted_14 = { key: 1 }
const _hoisted_15 = { key: 0 }
const _hoisted_16 = ["disabled"]
const _hoisted_17 = { key: 1 }
const _hoisted_18 = ["disabled"]
const _hoisted_19 = { key: 2 }
const _hoisted_20 = ["disabled"]
const _hoisted_21 = ["disabled"]
const _hoisted_22 = ["selected", "value"]
const _hoisted_23 = { key: 1 }
const _hoisted_24 = { class: "col-12 mb-4" }
const _hoisted_25 = { class: "flex items-center" }
const _hoisted_26 = ["onClick"]
const _hoisted_27 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("svg", {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 20 20",
  class: "w-4 h-4 fill-current"
}, [
  /*#__PURE__*/_createElementVNode("path", { d: "M1 4c0-1.1.9-2 2-2h14a2 2 0 0 1 2 2v14a2 2 0 0 1-2 2H3a2 2 0 0 1-2-2V4zm2 2v12h14V6H3zm2-6h2v2H5V0zm8 0h2v2h-2V0zM5 9h2v2H5V9zm0 4h2v2H5v-2zm4-4h2v2H9V9zm0 4h2v2H9v-2zm4-4h2v2h-2V9zm0 4h2v2h-2v-2z" })
], -1))
const _hoisted_28 = [
  _hoisted_27
]
const _hoisted_29 = ["value", "onClick"]
const _hoisted_30 = {
  value: null,
  disabled: "",
  selected: ""
}
const _hoisted_31 = ["value"]
const _hoisted_32 = { key: 1 }
const _hoisted_33 = { class: "col-12 d-flex justify-content-center" }
const _hoisted_34 = ["disabled"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_DatePicker = _resolveComponent("DatePicker")!
  const _directive_maska = _resolveDirective("maska")!

  return (_openBlock(), _createElementBlock("div", null, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _createElementVNode("div", _hoisted_3, [
          _createElementVNode("div", _hoisted_4, [
            _createElementVNode("label", _hoisted_5, _toDisplayString(_ctx.$t("welcome.name")), 1),
            _withDirectives(_createElementVNode("input", {
              type: "text",
              "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.user.name) = $event)),
              name: "name",
              class: "form-control",
              autofocus: "",
              id: "name",
              autocomplete: "name",
              "aria-describedby": "emailHelp"
            }, null, 512), [
              [_vModelText, _ctx.user.name]
            ])
          ]),
          _createElementVNode("div", _hoisted_6, [
            _createElementVNode("label", _hoisted_7, _toDisplayString(_ctx.$t("welcome.phone")), 1),
            _withDirectives(_createElementVNode("input", {
              type: "text",
              name: "tel",
              id: "tel",
              autocomplete: "tel",
              maxlength: "13",
              placeholder: "+380000000000",
              "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.user.phone) = $event)),
              class: "form-control",
              "aria-describedby": "emailHelp"
            }, null, 512), [
              [_directive_maska, '+380#########'],
              [_vModelText, _ctx.user.phone]
            ])
          ]),
          _createElementVNode("div", _hoisted_8, [
            (!_ctx.config.hideBooking)
              ? (_openBlock(), _createElementBlock("div", {
                  key: 0,
                  class: _normalizeClass(!_ctx.later ? 'tab-styles' : 'tab-styles-inactive'),
                  onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.later = false))
                }, [
                  _createElementVNode("span", null, _toDisplayString(_ctx.$t("welcome.now")), 1)
                ], 2))
              : _createCommentVNode("", true),
            (!_ctx.config.hideBooking)
              ? (_openBlock(), _createElementBlock("div", {
                  key: 1,
                  class: _normalizeClass(_ctx.later ? 'tab-styles' : 'tab-styles-inactive'),
                  onClick: _cache[3] || (_cache[3] = ($event: any) => (_ctx.later = true))
                }, [
                  _createElementVNode("span", null, _toDisplayString(_ctx.$t("welcome.booking")), 1)
                ], 2))
              : _createCommentVNode("", true)
          ]),
          _createElementVNode("div", _hoisted_9, [
            (!_ctx.later)
              ? (_openBlock(), _createElementBlock("div", _hoisted_10, [
                  _createElementVNode("div", _hoisted_11, [
                    (_ctx.config.hideOtpP)
                      ? (_openBlock(), _createElementBlock("div", _hoisted_12, [
                          _createElementVNode("button", {
                            onClick: _cache[4] || (_cache[4] = ($event: any) => (_ctx.joinRoom())),
                            disabled: _ctx.loading,
                            type: "button",
                            class: "btn btn-lg btn-warning shadow"
                          }, _toDisplayString(_ctx.$t("welcome.continue")), 9, _hoisted_13)
                        ]))
                      : (_openBlock(), _createElementBlock("div", _hoisted_14, [
                          (!_ctx.otpSent && !_ctx.otpVerified)
                            ? (_openBlock(), _createElementBlock("div", _hoisted_15, [
                                _createElementVNode("button", {
                                  onClick: _cache[5] || (_cache[5] = ($event: any) => (_ctx.sendOtp())),
                                  disabled: _ctx.loading,
                                  type: "button",
                                  class: "btn btn-lg btn-warning shadow"
                                }, _toDisplayString(_ctx.$t("welcome.otpButtonTitle")), 9, _hoisted_16)
                              ]))
                            : (_ctx.otpSent && !_ctx.otpVerified)
                              ? (_openBlock(), _createElementBlock("div", _hoisted_17, [
                                  _withDirectives(_createElementVNode("input", {
                                    type: "text",
                                    "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((_ctx.otpInput) = $event)),
                                    placeholder: "XXXXXX",
                                    class: "form-control mb-3"
                                  }, null, 512), [
                                    [_vModelText, _ctx.otpInput]
                                  ]),
                                  _createElementVNode("button", {
                                    onClick: _cache[7] || (_cache[7] = ($event: any) => (_ctx.checkOtp())),
                                    disabled: _ctx.loading,
                                    type: "button",
                                    class: "btn btn-lg btn-warning shadow"
                                  }, _toDisplayString(_ctx.$t("welcome.otpCheckButtonTitle")), 9, _hoisted_18),
                                  _createElementVNode("p", null, _toDisplayString(_ctx.$t("welcome.otpLeftTry")) + _toDisplayString(3 - _ctx.otpAttempts), 1)
                                ]))
                              : (_ctx.otpVerified)
                                ? (_openBlock(), _createElementBlock("div", _hoisted_19, [
                                    _createElementVNode("button", {
                                      onClick: _cache[8] || (_cache[8] = ($event: any) => (_ctx.joinRoom())),
                                      disabled: _ctx.loading,
                                      type: "button",
                                      class: "btn btn-lg btn-warning shadow"
                                    }, _toDisplayString(_ctx.$t("welcome.continue")), 9, _hoisted_20)
                                  ]))
                                : _createCommentVNode("", true)
                        ])),
                    _createElementVNode("select", {
                      disabled: _ctx.loading,
                      autocomplete: "off",
                      class: "form-select",
                      onChange: _cache[9] || (_cache[9] = ($event: any) => (_ctx.switchLocale($event.target.value)))
                    }, [
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.locales, (locale) => {
                        return (_openBlock(), _createElementBlock("option", {
                          selected: locale === _ctx.$i18n.locale,
                          key: locale,
                          value: locale
                        }, _toDisplayString(locale), 9, _hoisted_22))
                      }), 128))
                    ], 40, _hoisted_21)
                  ])
                ]))
              : _createCommentVNode("", true),
            (_ctx.later)
              ? (_openBlock(), _createElementBlock("div", _hoisted_23, [
                  _createElementVNode("div", _hoisted_24, [
                    _createVNode(_component_DatePicker, {
                      "min-date": new Date(),
                      class: "inline-block h-full",
                      modelValue: _ctx.bookingDate,
                      "onUpdate:modelValue": _cache[10] || (_cache[10] = ($event: any) => ((_ctx.bookingDate) = $event))
                    }, {
                      default: _withCtx(({ inputValue, togglePopover }) => [
                        _createElementVNode("div", _hoisted_25, [
                          _createElementVNode("button", {
                            class: "btn btn-lg btn-warning shadow calendar-button",
                            onClick: ($event: any) => (togglePopover())
                          }, _hoisted_28, 8, _hoisted_26),
                          _createElementVNode("input", {
                            value: inputValue,
                            class: "bg-white text-gray-700 w-full py-1 px-2 appearance-none border rounded-r focus:outline-none focus:border-blue-500",
                            readonly: "",
                            onClick: ($event: any) => (togglePopover())
                          }, null, 8, _hoisted_29)
                        ])
                      ]),
                      _: 1
                    }, 8, ["min-date", "modelValue"])
                  ]),
                  _createElementVNode("div", {
                    class: _normalizeClass(["col-12 mb-4", _ctx.notAvaiableDate ? 'no-free-time' : ''])
                  }, [
                    (!_ctx.notAvaiableDate && _ctx.bookingFreeDates().length > 0)
                      ? _withDirectives((_openBlock(), _createElementBlock("select", {
                          key: 0,
                          style: {"width":"100%"},
                          autocomplete: "off",
                          class: "form-select",
                          "onUpdate:modelValue": _cache[11] || (_cache[11] = ($event: any) => ((_ctx.setBookingDate) = $event))
                        }, [
                          _createElementVNode("option", _hoisted_30, _toDisplayString(_ctx.$t("welcome.chooseDate")), 1),
                          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.bookingFreeDates(), (time) => {
                            return (_openBlock(), _createElementBlock("option", {
                              key: time,
                              value: time
                            }, _toDisplayString(time), 9, _hoisted_31))
                          }), 128))
                        ], 512)), [
                          [_vModelSelect, _ctx.setBookingDate]
                        ])
                      : _createCommentVNode("", true),
                    (_ctx.notAvaiableDate)
                      ? (_openBlock(), _createElementBlock("span", _hoisted_32, _toDisplayString(_ctx.$t("welcome.errorTime")), 1))
                      : _createCommentVNode("", true)
                  ], 2),
                  _createElementVNode("div", _hoisted_33, [
                    _createElementVNode("button", {
                      onClick: _cache[12] || (_cache[12] = ($event: any) => (_ctx.bookingRoom())),
                      disabled: _ctx.loading,
                      type: "button",
                      class: "btn btn-lg btn-warning shadow"
                    }, _toDisplayString(_ctx.$t("welcome.continue")), 9, _hoisted_34)
                  ])
                ]))
              : _createCommentVNode("", true)
          ])
        ])
      ])
    ])
  ]))
}